import { render, staticRenderFns } from "./DefaultDisplayStage.vue?vue&type=template&id=26f6f36e&scoped=true&"
import script from "./DefaultDisplayStage.vue?vue&type=script&lang=js&"
export * from "./DefaultDisplayStage.vue?vue&type=script&lang=js&"
import style0 from "./DefaultDisplayStage.vue?vue&type=style&index=0&id=26f6f36e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f6f36e",
  null
  
)

export default component.exports